var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoschLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.4 96.4",
    style: {
      enableBackground: "new 0 0 96.4 96.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2,0C21.6,0,0,21.6,0,48.2s21.6,48.2,48.2,48.2s48.2-21.6,48.2-48.2S74.8,0,48.2,0C48.2,0,48.2,0,48.2,0z M48.2,91.9 c-24.1,0-43.7-19.6-43.7-43.7S24.1,4.5,48.2,4.5s43.7,19.6,43.7,43.7C91.9,72.3,72.3,91.9,48.2,91.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,18.1h-3.3v16.5H31.7V18.1h-3.4c-16.6,11-21.2,33.3-10.2,50c2.7,4.1,6.2,7.6,10.2,10.2h3.4V61.8h33.1v16.5h3.3 c16.6-11,21.2-33.3,10.3-49.9C75.7,24.3,72.2,20.8,68.1,18.1L68.1,18.1z M27.1,71.8c-13-11.6-14.2-31.6-2.6-44.6c0,0,0,0,0,0 c0.8-0.9,1.7-1.8,2.6-2.6L27.1,71.8z M64.8,57.2H31.7V39.1h33.1V57.2z M69.3,71.7v-10l0,0V34.6l0,0v-10 c13,11.7,14.1,31.7,2.4,44.7c0,0,0,0,0,0C70.9,70.1,70.1,70.9,69.3,71.7L69.3,71.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoschLogo);
export default __webpack_public_path__ + "static/media/bosch_logo.f401fa9db34520425ac6b0491f7f9008.svg";
export { ForwardRef as ReactComponent };